<ng-container *ngIf="question">
    <div dwRow class="poa-question-row">
        <div dwCol="2" *ngIf="showAcsCode" class="poa-question-acs-code">
            <label class="label" [hidden]="hideLabels">ACS Code  <i class="fa fa-times dw-red" title="Missed ACS Code" [hidden]="!isMissedCode"></i></label>

            <ng-container *ngIf="!inEditMode">
                <div class="form-control" [class.form-control-expandable]="!readOnly" (click)="enableEditMode()">{{currentAcsCode?.AcsCode}}</div>

            </ng-container>
            <ng-container *ngIf="inEditMode">
                <p-dropdown [options]="currentAcsCodes" optionLabel="AcsCode" display="chip" optionValue="AcsCodeId"
                    [(ngModel)]="question.AcsCodeId" (ngModelChange)="onAcsCodeChanged($event)" [style]="{'width':'100%'}"
                    [filter]="true" appendTo="body" [disabled]="readOnly" [readonly]="readOnly"></p-dropdown>

                
            </ng-container>
        </div>
        <div [dwCol]="showAcsCode ? 10 : 12" *ngIf="showQuestion" class="poa-question-main">
            <div class="poa-question-header">
                <label class="label pull-left" [hidden]="hideLabels">Question</label>

                <div *ngIf="!showAcsCode" class="pull-right poa-question-notes-toggle">
                    Show Notes 
                    <!-- <p-inputSwitch  [(ngModel)]="question.ShowNotes"></p-inputSwitch> -->
                    <input type="checkbox" [(ngModel)]="question.ShowNotes" [disabled]="readOnly">
                </div>
            </div>

            <div *ngIf="!inEditMode" class="form-control poa-question-body" [class.form-control-expandable]="!readOnly" (click)="enableEditMode(true)">
                <dw-html-view [ngModel]="question.QuestionHtml"></dw-html-view>
            </div>
            <ng-container *ngIf="inEditMode">
                <div class="poa-question-body">
                <dw-html-edit [(ngModel)]="question.QuestionHtml" (ngModelChange)="onQuestionChange($event)"
                    (apiReady)="onQuestionEditorReady($event)"></dw-html-edit>
                </div>
            </ng-container>

            <span *ngIf="showAcsCode" class="poa-question-description">{{currentAcsCode?.AscCodeDescription}}</span>
        </div>
        <div dwCol="10" *ngIf="!showQuestion" class="poa-question-main">
            <label class="label" [hidden]="hideLabels">ACS Code Description</label>
            <div class="form-control form-control-expandable poa-question-body">
                <span *ngIf="showAcsCode">{{currentAcsCode?.AscCodeDescription}}</span>
            </div>
        </div>
        
    </div>
</ng-container>
